import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import { fetchAcademicSessions } from '../../../store/actions/academicSessionsActions'
// import SelectField from '../../elements/form/SelectField'
import ModalActionButton from '../../elements/ModalActionButton'
// import { fetchTerms } from '../../../store/actions/termsActions'
import { fetchAssessments } from '../../../store/actions/assessmentsActions'
import { fetchSubjects } from '../../../store/actions/subjectsActions'
import SelectField from '../../elements/form/SelectField'
import FileUpload from '../../elements/form/FileUpload'
import ArrowDownTrayIcon from '../../elements/icons/ArrowDownTrayIcon'
import { ERROR, SET_SUCCESS } from '../../../store/types'
import Papa from 'papaparse'
import axios from 'axios'
import { authHeader, baseUrl } from '../../../utils'

const UploadAssessmentRecords = ({
    subject,
    assessment,
    close,
    reload
}) => {

    const [recordPayload, setRecordPayload] = useState({})
    const [validationErrors, setValidationErrors] = useState({})
    const [parsedRecords, setParsedRecords] = useState([])
    const [isParsing, setIsParsing] = useState(false)
    const [parseProgress, setParseProgress] = useState(0)
    const [isUploading, setIsUploading] = useState(false)
    const [uploadErrors, setUploadErrors] = useState([])
    const [uploadSummary, setUploadSummary] = useState(null)
    const [uploaderKey, setUploaderKey] = useState(0)
    
    const dispatch = useDispatch()
    const subjectsSelector = useSelector(state => state.subjects)
    const assessmentsSelector = useSelector((state => state.assessments))
    
    useEffect(() => {

        if(!subject) {
            dispatch(fetchSubjects('', 0, 0))
        } 
        
        if(!assessment) {
            dispatch(fetchAssessments('', 0, 0))
        }
    
        return () => {
            
        }
    }, [assessment, dispatch, subject])

    
    const [file, setFile] = useState(null);

    const normalizeCsvHeader = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '')

    const parseUploadedCsv = (csvFile) => {
        if (!csvFile) {
            setParsedRecords([])
            setIsParsing(false)
            setParseProgress(0)
            return
        }

        setIsParsing(true)
        setParseProgress(0)
        setParsedRecords([])

        const transformedRecords = []
        const invalidRows = []
        let parsedDataRows = 0

        Papa.parse(csvFile, {
            header: true,
            skipEmptyLines: true,
            step: (results) => {
                parsedDataRows += 1

                const normalizedRow = {}
                const row = results?.data || {}
                Object.keys(row).forEach((key) => {
                    normalizedRow[normalizeCsvHeader(key)] = row[key]
                })

                const student = String(
                    normalizedRow.studentadmissionnumber ||
                    normalizedRow.admissionnumber ||
                    normalizedRow.student ||
                    ''
                ).trim()

                const score = Number(String(normalizedRow.score || '').replace(/,/g, '').trim())
                const outOf = Number(
                    String(
                        normalizedRow.outof ||
                        normalizedRow.outoff ||
                        normalizedRow.total ||
                        ''
                    ).replace(/,/g, '').trim()
                )

                if (!student || Number.isNaN(score) || Number.isNaN(outOf) || outOf <= 0) {
                    invalidRows.push(parsedDataRows + 1)
                    return
                }

                transformedRecords.push({
                    student,
                    score,
                    outOf,
                    percentageScore: Number(((score / outOf) * 100).toFixed(2))
                })

                if (csvFile.size && results?.meta?.cursor) {
                    const nextProgress = Math.min(99, Math.floor((results.meta.cursor / csvFile.size) * 100))
                    setParseProgress((prev) => nextProgress > prev ? nextProgress : prev)
                }
            },
            complete: () => {
                setIsParsing(false)
                setParseProgress(100)

                if (!parsedDataRows) {
                    setParsedRecords([])
                    dispatch({
                        type: ERROR,
                        error: {response: {data: {
                            message: 'CSV file is empty. Please upload a file with at least one record.'
                        }}}
                    })
                    return
                }

                if (invalidRows.length > 0) {
                    setParsedRecords([])
                    dispatch({
                        type: ERROR,
                        error: {response: {data: {
                            message: `Invalid data on row(s): ${invalidRows.join(', ')}. Ensure Student Admission Number, Score, and Out Of are valid.`
                        }}}
                    })
                    return
                }

                setParsedRecords(transformedRecords)
            },
            error: () => {
                setIsParsing(false)
                setParseProgress(0)
                setParsedRecords([])
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'Could not read the uploaded CSV file. Please try again.'
                    }}}
                })
            }
        })
    }

    const validateForm = () => {
        let errors = {}

        if(!file) {
            errors.file = true
        }

        if(!parsedRecords || parsedRecords.length < 1) {
            errors.records = true
        }

        if(!subject && (!recordPayload.subject || recordPayload.subject === '')) {
            errors.subject = true
        }

        if(!assessment && (!recordPayload.assessment || recordPayload.assessment === '')) {
            errors.assessment = true
        }

        setValidationErrors(errors)
        return errors
    }

    const clearUploadedFileState = () => {
        setFile(null)
        setParsedRecords([])
        setParseProgress(0)
        setIsParsing(false)
        setValidationErrors({})
        setUploaderKey((prev) => prev + 1)
    }

    const pushRecords = async () => {
        if (isParsing) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'CSV parsing is in progress. Please wait for it to complete.'
                }}}
            })
            return
        }

        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            });
            return
        }

        const payload = {
            records: parsedRecords,
            subject: subject ? subject._id : recordPayload.subject,
            assessment: assessment ? assessment._id : recordPayload.assessment
        }

        const headers = authHeader()

        try {
            setIsUploading(true)
            setUploadErrors([])
            setUploadSummary(null)

            const response = await axios.post(`${baseUrl}/assessment-records/multiple`, payload, { headers })
            const responseData = response?.data?.data || {}
            const createdRecords = Array.isArray(responseData?.data) ? responseData.data : []
            const failedRows = Array.isArray(responseData?.errors) ? responseData.errors : []

            if (failedRows.length > 0) {
                setUploadErrors(failedRows)
                setUploadSummary({
                    uploadedCount: createdRecords.length,
                    failedCount: failedRows.length,
                    totalCount: createdRecords.length + failedRows.length
                })
                return
            }

            dispatch({
                type: SET_SUCCESS,
                payload: responseData?.message || response?.data?.message || 'Assessment records uploaded successfully!'
            })

            setUploadSummary({
                uploadedCount: createdRecords.length,
                failedCount: 0,
                totalCount: createdRecords.length
            })

            if (typeof reload === 'function') {
                reload()
            }

            clearUploadedFileState()
        } catch (error) {
            dispatch({
                type: ERROR,
                error
            })
        } finally {
            setIsUploading(false)
        }

    }

    const templateUrl = 'https://res.cloudinary.com/dnyft23lb/raw/upload/v1786460980/vcm-assessment-scores-upload-template_tltwao.csv'

    const downloadTemplate = () => {
        const link = document.createElement('a')
        link.href = templateUrl
        link.download = 'vcm-assessment-scores-upload-template.csv'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    

    return (
        <div className='pt-[20px] border-t border-gray-300'>
            
            {subjectsSelector?.subjects?.subjects && subjectsSelector?.subjects?.subjects?.length > 0 && <div className='w-full mt-[10px] mb-[10px]'>
                <SelectField
                    selectOptions={subjectsSelector?.subjects?.subjects}
                    inputLabel="Select Subject"
                    titleField="name"
                    displayImage={false}
                    imageField=""
                    // preSelected=''
                    fieldId="subject"
                    hasError={validationErrors.subject}
                    preSelected={subject ? subject._id : ''}
                    preSelectedLabel={'_id'}
                    // return id of accounts of the selected option
                    returnFieldValue={(value) => {
                        setRecordPayload({...recordPayload, ...{subject: value._id}})
                    }}
                    disabled={subject && subject !== null}
                />
            </div>}

            {assessmentsSelector?.assessments?.assessments && assessmentsSelector?.assessments?.assessments?.length > 0 && <div className='w-full mt-[10px] mb-[25px]'>
                <SelectField
                    selectOptions={assessmentsSelector?.assessments?.assessments}
                    inputLabel="Select Assessment"
                    titleField="name"
                    displayImage={false}
                    imageField=""
                    // preSelected=''
                    fieldId="assessment"
                    hasError={validationErrors.assessment}
                    preSelected={assessment ? assessment._id : ''}
                    preSelectedLabel={'_id'}
                    // return id of accounts of the selected option
                    returnFieldValue={(value) => {
                        setRecordPayload({...recordPayload, ...{assessment: value._id}})
                    }}
                    disabled={assessment && assessment !== null}
                />
            </div>}

            <div className='w-full p-4 rounded-lg bg-gray-50 border border-gray-300 my-4'>
                <h3 className="text-sm font-[550] font-space-grotesk">Template</h3>
                <p className="text-sm text-gray-500">Template (.csv) for student assessment scores. The template should contain the following columns: Student Admission Number, Score, Out Of. You can download a sample template below.</p>

                <button className="inline-flex mt-4 justify-center gap-x-2 px-5 py-2 text-xs font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none transition duration-200 cursor-pointer border border-dashed border-gray-600" onClick={downloadTemplate}>
                    <ArrowDownTrayIcon className={`w-5 h-5`} />
                    Download Sample Template
                </button>
            </div>

            <p className="text-sm mb-2">Upload the completed template below</p>

            <FileUpload
                key={uploaderKey}
                hasError={validationErrors.file}
                fieldLabel={`Completed CSV Document`}
                returnFileDetails={(details)=>{
                    setValidationErrors((prev) => ({ ...prev, file: false, records: false }))
                    setUploadErrors([])
                    setUploadSummary(null)
                    setFile(details)
                    parseUploadedCsv(details?.file)
                }}
                requiredField={true}
                maxFileSize={200}
                acceptedFormats={['csv']}
            />

            {isParsing && <div className="mt-3 mb-3">
                <div className="flex items-center justify-between mb-1">
                    <p className="text-xs text-gray-600">Parsing CSV...</p>
                    <p className="text-xs text-gray-600">{parseProgress}%</p>
                </div>
                <div className="w-full h-2 rounded-full bg-gray-200 overflow-hidden">
                    <div
                        className="h-2 bg-vcm-green transition-all duration-200"
                        style={{ width: `${parseProgress}%` }}
                    />
                </div>
            </div>}

            {!isParsing && parsedRecords && parsedRecords.length > 0 && <p className="text-xs text-green-700 mb-2">{parsedRecords.length} record(s) parsed successfully.</p>}

            {uploadSummary && uploadSummary.failedCount < 1 && <div className='mt-3 mb-2 p-3 rounded-md bg-green-50 border border-green-200'>
                <p className='text-sm text-green-800 font-medium'>Upload complete.</p>
                <p className='text-xs text-green-700 mt-1'>{uploadSummary.uploadedCount} record(s) were uploaded successfully.</p>
            </div>}

            {uploadErrors && uploadErrors.length > 0 && <div className='mt-3 mb-2 p-3 rounded-md bg-yellow-50 border border-yellow-300'>
                <p className='text-sm text-yellow-900 font-medium'>Some errors were found while uploading.</p>
                {uploadSummary && <p className='text-xs text-yellow-800 mt-1'>{uploadSummary.uploadedCount} uploaded, {uploadSummary.failedCount} failed.</p>}
                <div className='mt-2 max-h-[180px] overflow-y-auto pr-1'>
                    {uploadErrors.map((item, index) => (
                        <div key={`${item.student}-${index}`} className='text-xs text-yellow-900 mb-2 pb-2 border-b border-yellow-200 last:border-b-0'>
                            <p className='font-medium'>{item.student || 'Unknown student'}</p>
                            <p>{item.message || 'An unknown error occurred'}</p>
                        </div>
                    ))}
                </div>
            </div>}

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={'Upload Assessment Scores'}
                    buttonAction={()=>{pushRecords()}}
                    processing={isUploading}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={()=>{close()}}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default UploadAssessmentRecords